import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined'
import PeopleOutline from '@mui/icons-material/PeopleOutline'
import { IconButton, Tooltip } from '@mui/material'
import { NutritionistNextCall } from 'components/NutritionistNextCall'
import { LocationPaths } from 'location.types'
import { useNavigate } from 'react-router'

export const NutritionistLeftAdornment = () => {
  const navigate = useNavigate()

  return (
    <>
      <Tooltip title="Daily Appointments">
        <IconButton edge="start" onClick={() => navigate(`${LocationPaths.NutritionistHome}/`)}>
          <CalendarTodayOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Members Management">
        <IconButton edge="start" onClick={() => navigate(`${LocationPaths.MembersManagement}/`)}>
          <PeopleOutline />
        </IconButton>
      </Tooltip>
      <NutritionistNextCall />
    </>
  )
}
